import { Editor } from '@tinymce/tinymce-react';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react'
import { ContentType } from '../../../Enumerators/ContentType';
import { News } from '../../../Models/News';
import { useStore } from '../../../Stores/store';

export default observer(function NewsForm() {
    const { generalStore } = useStore();
    const { selectedNews, addUpdateNews } = generalStore;
    const apiKey: string | undefined = process.env.REACT_APP_TINY_MCE_KEY;

    let editNews: News | undefined = undefined;
    if(selectedNews !== undefined) editNews = {...selectedNews}
    const formVals : News = editNews ?? {
      id: 0,
      title: "",
      content: "",
      type: ContentType.news
    }

    const handleSubmit = (values : any) => {
      addUpdateNews(values);
    }

    return (
      <Formik
      initialValues={formVals}
      onSubmit={(values) => handleSubmit(values)}
      enableReinitialize
      >
      {({handleSubmit, handleChange, values}) => (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label htmlFor="title" className="text-sm font-medium text-gray-700">News Title</label>
            <input type="text" name="title" id="title" value={values.title} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500" />
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="content" className="text-sm font-medium text-gray-700">Content</label>
            <Editor
              apiKey={apiKey}
              initialValue="<p>News...</p>"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image",
                  "charmap print preview anchor help",
                  "searchreplace visualblocks code",
                  "insertdatetime media table paste wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | help",
              }}
              onChange={handleChange}
              onEditorChange={(e) => {
                handleChange({target: {name: "content", value: e}})
              }}
              value={values.content}
            />
          </div>
          <input type="hidden" id="id" name="id" value={values.id} />
          <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">Submit News</button>
        </form>
      )}
    </Formik>
    );
});